<div *ngIf="loading" class="portal-loading" role="status">
  <p>Loading account information…</p>
  <mat-progress-bar mode="indeterminate" aria-label="Loading account information"></mat-progress-bar>
</div>
<section *ngIf="!loading" class="portal-prose">
  <h1 class="portal-page-title mb-6">Account information</h1>
  <mat-card>
    <mat-card-content>
      <dl class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <dt class="font-semibold">Account name</dt><dd>{{username}}</dd>
        <dt class="font-semibold">Email address</dt><dd class="break-words">{{email}}</dd>
      </dl>
    </mat-card-content>
  </mat-card>
  <mat-card class="mt-6" *ngIf="roles != null && roles.length > 0">
    <mat-card-content>
      <h2 class="portal-section-title">Roles</h2>
      <ul><li *ngFor="let role of roles">{{role}}</li></ul>
    </mat-card-content>
  </mat-card>
</section>
